<template>
  <div class="flex flex-col lg:flex-row heightfix justify-center" v-if="!isGoogleLogging">
   <div class="lg:w-[45%] relative hidden lg:block">
      <!-- <img :src="login_logo" class="w-[200px] h-[30px] absolute top-8 left-8" alt="" /> -->
      <img
        :src="login_logo"
        class="w-[200px] h-[50px] absolute top-8 left-8 object-contain  lg:flex"
        alt=""
      />

      <img
        src="@/assets/newd/testbg.png"
        class="w-full h-[450px] lg:h-full  lg:flex"
        alt=""
      />
      <img
        src="@/assets/loginbg.svg"
        class="absolute bottom-0 h-[350px] lg:h-[580px]  2xl:h-[85%] lg:-right-[20%]  lg:flex"
        alt=""
      />
    </div>
    <div class="flex justify-center lg:hidden">
      <img
        :src="mobile_logo"
        class="w-[200px] h-[50px]  object-contain  lg:flex"
        alt=""
      />
    </div>
    <div
      class="flex flex-col gap-10 p-10 lg:items-center lg:w-[65%] lg:justify-center"
    >
      <form
        v-if="changeMenu === 'passowrd'"
        @submit.prevent="restpassword()"
        class="lg:w-[50%] flex flex-col gap-4"
      >
        <h2 class="text-2xl lg:text-4xl font-bold">Forgot Password</h2>

        <div>
          <label class="leading-7 text-sm text-gray-600">Reset Password</label>
          <input
            @change="emptyspaceremove"
            :type="showPassword ? 'text' : 'password'"
            id="resetpassword"
            v-model="password"
            name="Resetpassword"
            class="w-full bg-white rounded border border-gray-300 focus:primary-border focus:ring-2 focus:primary-border text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
            placeholder="reset password"
            required
          />
          <img
            v-if="!showPassword"
            src="@/assets/eyeslash.svg"
            @click="togglePassword('reset')"
            alt=""
            class="cursor-pointer inline-block z-50"
            style="margin-left: -30px"
          />
          <img
            v-else
            src="@/assets/eye.svg"
            @click="togglePassword('reset')"
            alt=""
            class="cursor-pointer inline-block z-50"
            style="margin-left: -30px"
          />
        </div>

        <div>
          <label class="leading-7 text-sm text-gray-600"
            >Confirm Password</label
          >
          <input
            @change="emptyspaceremove"
            :type="showConfirmPassword ? 'text' : 'password'"
            id="conformpassword"
            name="conformpassword"
            v-model="confirmPassword"
            class="w-full bg-white rounded border border-gray-300 focus:primary-border focus:ring-2 focus:primary-border text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
            placeholder="Confirm password"
            required
          />
          <img
            v-if="!showConfirmPassword"
            src="@/assets/eyeslash.svg"
            @click="togglePassword('confirm')"
            alt=""
            class="cursor-pointer inline-block z-50"
            style="margin-left: -30px"
          />
          <img
            v-else
            src="@/assets/eye.svg"
            @click="togglePassword('confirm')"
            alt=""
            class="cursor-pointer inline-block z-50"
            style="margin-left: -30px"
          />
        </div>

        <h1 v-if="loginErrors" class="text-red-700 font-semibold p-2 text-base">
          {{ loginErrors }}
        </h1>
        <p v-if="loginsuccess" class="text-green-400 font-semibold text-base">
          {{ loginsuccess }}
        </p>

        <!-- <button
          type="button"
          @click="changeMenu = 'forget'"
          class="text-left px-2 py-1 text-sm text-sky-600 hover:text-red-500"
        >
          Login with Password?
        </button> -->
        <router-link
          :to="{ name: 'Login' }"
          class="text-left px-2 py-1 text-sm text-sky-600 hover:text-red-500"
        >
          Login with Password?
        </router-link>

        <div class="flex justify-end mt-4 bottom-2">
          <button
            v-if="!loading"
            type="submit"
            class="bg-black text-white py-2 px-6 text-sm rounded-lg hover:bg-blue-700 transition relative"
            style="background-color: #0f172a !important"
          >
            Reset Password
          </button>
          <div v-if="loading" class="flex gap-5 items-center">
            <button
              type="submit"
              class="bg-black text-white py-2 px-6 text-sm rounded-lg hover:bg-blue-700 transition relative"
              style="background-color: #0f172a !important"
            >
              Loading...
            </button>
            <div>
              <div>
                <div class="spinner"></div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
export default {
  data: function () {
    return {
      login_logo: require(`${process.env.VUE_APP_LOGIN_COMS_LOGO}`),
      mobile_logo: require(`${process.env.VUE_APP_LOGIN_COMS_MOBILE_LOGO}`),
      login: {
        username: "",
        password: "",
      },
      loading: false,
      passwordType: "password",
      varificationPopup: true,
      credentialsError: "",
      messages: {
        text: "",
        type: "null",
      },
      changeMenu: "passowrd",
      loginsuccess: null,
      loginErrors: null,
      token: null,
      password: "",
      confirmPassword: "",
      showPassword: false,
      showConfirmPassword: false,
    };
  },
  created() {
    const url = window.location.href;
    this.token = url.split("/").pop();
    console.log("Reset token:", this.token);
  },

  computed: mapGetters(["userInfo", "loginError", "isAuthenticated"]),
  mounted() {},
  methods: {
    ...mapActions([
      "loginUser",
      "subcription",
      "instructordetails",
      "loginWithGoogle",
      "getNotifications",
    ]),

    togglePassword(field) {
      if (field === "reset") {
        this.showPassword = !this.showPassword;
      } else if (field === "confirm") {
        this.showConfirmPassword = !this.showConfirmPassword;
      }
    },

    restpassword() {
      if (!this.password || !this.confirmPassword) {
        this.loginErrors = "Both fields are required!";
        setTimeout(() => (this.loginErrors = ""), 800);
        return;
      }
      if (this.password !== this.confirmPassword) {
        this.loginErrors = "Passwords do not match!";
        setTimeout(() => {
          this.loginErrors = "";
        }, 800);
        return;
      }
      this.loading = true;

      const resetpwd = {
        token: this.token,
        password: this.confirmPassword,
      };
      console.log("resetpwd", resetpwd);

      axios
        .post(
          `${process.env.VUE_APP_API}/api/password_reset/confirm/`,
          resetpwd
        )
        .then((response) => {
          console.log("responseresponseresponseresponse", response);
          if (response.data.status == "OK") {
            this.loading = false;
            this.loginsuccess = "Rest Password Successfully";

            setTimeout(() => {
              this.loginsuccess = "";
              this.$router.push({
                name: "Login",
              });
            }, 2500);
          }
        })
        .catch((error) => {
          console.log("error...", error);
          this.loginErrors =
            "The OTP password entered is not valid. Please check and try again.";
          setTimeout(() => {
            this.loginErrors = "";
            this.loading = false;
          }, 2500);
        });
    },
    emptyspaceremove(el) {
      el.target.value = el.target.value.trim();
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh) !important;
}
.spinner {
  --d: 8.6px;
  width: 1.5px;
  height: 1.5px;
  border-radius: 50%;
  color: #a6acb7;
  box-shadow: calc(1 * var(--d)) calc(0 * var(--d)) 0 0,
    calc(0.707 * var(--d)) calc(0.707 * var(--d)) 0 0.5px,
    calc(0 * var(--d)) calc(1 * var(--d)) 0 1px,
    calc(-0.707 * var(--d)) calc(0.707 * var(--d)) 0 1.4px,
    calc(-1 * var(--d)) calc(0 * var(--d)) 0 1.9px,
    calc(-0.707 * var(--d)) calc(-0.707 * var(--d)) 0 2.4px,
    calc(0 * var(--d)) calc(-1 * var(--d)) 0 2.9px;
  animation: spinner-a90wxe 1s infinite steps(8);
}

@keyframes spinner-a90wxe {
  100% {
    transform: rotate(1turn);
  }
}
</style>
